module.exports = __webpack_public_path__ + "static/img/nav12.d4785995.svg";